export const Constants = {
    GBE: 'GBE',
    GDC: 'GDC',
    GRI: 'GRI',
    GTE: 'GTE',
    PLATFORM_PMM: 'PMM',
    PLATFORM_CUPS: 'CUPS',
    ALL_TYPES_OF_PRINTING: 'ALL_TYPES_OF_PRINTING',
    GUIDE_PLATFORM: "GUIDE_PLATFORM",
    GUIDE_TRAVEL: {
        PURCHASE: 'COMPRA',
        SALE: 'VENTA',
        PROPERTY_TRANSFER: 'TRASLADO DE BIENES PARA TRASFORMACION',
        CONSIGNMENT: 'CONSIGNACION',
        RETURN: 'DEVOLUCION',
        TRANSFER_BETWEEN_ESTABLISHMENTS: 'TRASLADO ENTRE ESTABLECIMIENTOS DE UNA MISMA EMPRESA',
        TRANSFER_BY_ITINERANT_ISSUER: 'TRASLADO POR EMISOR ITINERANTE DE COMPROBANTE DE PAGO',
        HOUSING_COLLECTION: 'RECOJO DE BIENES',
        PRIMARY_AREA_TRANSFER: 'TRASLADO DE ZONA PRIMARIA',
        IMPORT: 'IMPORTACION',
        EXPORT: 'EXPORTACION',
        RETURN_TO_PROVIDER: 'Devolución a proveedor',
        TRANSFER_BY_ISSUER: 'Traslado por emisor',
        TRANSFORMATION: 'Trasformación',
        BUYER_CONFIRMATION: 'Venta sujeto a confirmación del comprador',
        OTHERS: 'OTHERS',
        getProps: () => [
            { id: 'SALE', text: 'Venta', OE: true, PRO: true, SPSA: true, HESA: true },
            { id: 'PURCHASE', text: 'Compra', OE: true, PRO: true, SPSA: false, HESA: true },
            { id: 'PROPERTY_TRANSFER', text: 'Traslado de bienes para trasformación', OE: true, PRO: true, SPSA: false, HESA: true },
            { id: 'TRANSFORMATION', text: 'Trasformación', OE: false, PRO: false, SPSA: true, HESA: false },
            { id: 'CONSIGNMENT', text: 'Consignación', OE: true, PRO: true, SPSA: true, HESA: true },
            { id: 'RETURN', text: 'Devolución', OE: true, PRO: true, SPSA: false, HESA: true },
            { id: 'TRANSFER', text: 'Transferencia', OE: false, PRO: false, SPSA: true, HESA: false },
            { id: 'TRANSFER_BETWEEN_ESTABLISHMENTS', text: 'Traslado entre establecimientos de una misma empresa', OE: true, PRO: true, SPSA: true, HESA: true },
            { id: 'TRANSFER_BY_ITINERANT_ISSUER', text: 'Traslado por emisor de comprobante de pago', OE: true, PRO: true, SPSA: false, HESA: true },
            { id: 'HOUSING_COLLECTION', text: 'Recojo de bienes', OE: true, PRO: true, SPSA: false, HESA: true },
            { id: 'BUYER_CONFIRMATION', text: 'Venta sujeto a confirmación del comprador', OE: false, PRO: true, SPSA: false, HESA: true },
            { id: 'PRIMARY_AREA_TRANSFER', text: 'Traslado de zona primaria', OE: true, PRO: true, SPSA: false, HESA: true },
            { id: 'IMPORT', text: 'Importación', OE: true, PRO: true, SPSA: false, HESA: true },
            { id: 'EXPORT', text: 'Exportación', OE: true, PRO: true, SPSA: false, HESA: true },
            { id: 'RETURN_TO_PROVIDER', text: 'Devolución a proveedor', OE: false, PRO: false, SPSA: true, HESA: false },
            { id: 'TRANSFER_BY_ISSUER', text: 'Traslado por emisor', OE: false, PRO: false, SPSA: true, HESA: false },
            { id: 'OTHERS', text: 'Otros', OE: true, PRO: true, SPSA: true, HESA: true },
        ]
    },
};
